import clsx from "clsx";
import React, { LabelHTMLAttributes, ReactNode } from "react";

import RequiredBadge from "components/RequiredBadge";
import { cn } from "utils/cn";

const FormRow = ({
  label,
  children,
  error,
  isPlural = false,
  isRequired = true,
  isTopErrorMessage = false,
  labelCenter = false,
  noBorder = false,
  gapSize = 4,
  labelMinWidth = "",
  htmlFor,
  ariaLabel,
  padding = "py-4",
  labelClass = "",
  wrapperClassName = "",
  contentClassName = "w-full",
}: {
  label: string | ReactNode;
  children: ReactNode;
  error?: string | undefined;
  isPlural?: boolean;
  isRequired?: boolean;
  isTopErrorMessage?: boolean;
  labelCenter?: boolean;
  noBorder?: boolean;
  gapSize?: number;
  labelMinWidth?: string;
  htmlFor?: LabelHTMLAttributes<HTMLLabelElement>["htmlFor"];
  ariaLabel?: string;
  padding?: string;
  labelClass?: string;
  wrapperClassName?: string;
  contentClassName?: string;
}) => {
  const labelClasses = clsx("min-w-[120px]", "text-left", isPlural && "self-start");
  const errorClasses = clsx(isTopErrorMessage ? "-mb-2" : "-mt-2", "text-xs", "font-bold", "text-attention");
  const containerClasses = clsx("flex", isTopErrorMessage ? "flex-col-reverse" : "flex-col", contentClassName, "gap-4");

  return (
    <div
      className={cn(
        "flex items-center justify-between border-normal",
        noBorder ? "border-none" : "border-b",
        padding,
        wrapperClassName
      )}
    >
      <div className={`flex items-center ${labelMinWidth} gap-2 ${labelCenter ? "self-auto" : "self-start pt-3"} ${labelClass}`}>
        <RequiredBadge isActive={isRequired} />
        <label htmlFor={htmlFor} className={labelClasses}>
          {label}
        </label>
      </div>
      <div className={containerClasses}>
        <div className={`flex flex-col gap-${gapSize}`}>{children}</div>
        {error && (
          <span className={errorClasses} role="alert" aria-label={ariaLabel}>
            {error}
          </span>
        )}
      </div>
    </div>
  );
};

export default FormRow;
